import { Box, Typography } from '@mui/material';
import { TrobberIcon } from 'svg/TrobberIcon';
import { useTranslation } from 'react-i18next';

// Крутящийся спиннер с текстом о том, что данные грузятся
export const Trobber = () => {
  const { t } = useTranslation();

  const renderContent = () => (
    <Box display='flex' flexDirection='column' alignItems='center' gap={4}>
      <TrobberIcon />
      <Typography variant='subtitle1'>{t('common.loading')}</Typography>
    </Box>
  );

  return renderContent();
};
